/*
  DogPure · carrito lateral DogPure (el de Dawn) cuando se agrega desde partes de Horizon
  (colecciones, búsqueda, agregado rápido). Horizon avisa con el evento estándar de carrito; aquí se piden las
  secciones del carrito DogPure y del contador del encabezado y se abre el carrito, como hacía Dawn.
  Los botones DogPure (<product-form>) ya actualizan el carrito por su cuenta y se ignoran.
*/
import { StandardEvents } from '@shopify/events';

const DP_SOURCES = 'product-form, cart-drawer, cart-items, dp-cart-upsell, dp-cart-upgrade';

function refreshDpCart() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.renderContents !== 'function') return;
  const root = window.Shopify?.routes?.root || '/';
  fetch(`${root}?sections=cart-drawer,cart-icon-bubble`)
    .then((response) => response.json())
    .then((sections) => {
      const open = () => drawer.renderContents({ sections });
      // Si la compra viene de un diálogo de Horizon (agregado rápido), se abre al cerrarlo
      const modal = document.querySelector('dialog:modal');
      if (modal) modal.addEventListener('close', open, { once: true });
      else open();
    })
    .catch(() => {});
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.target instanceof Element && event.target.closest(DP_SOURCES)) return;
  if (event.action !== 'add') return;
  event.promise
    ?.then((result) => {
      if (!result?.detail?.didError) refreshDpCart();
    })
    .catch(() => {});
});
